import animateScrollTo from "animated-scroll-to";

const setupScrolls = (container) => {
    const buttons = container.querySelectorAll(".scroll-to-button");

    if (!buttons) {
        return;
    }

    const clickHandler = (trigger) => {
        const scrollLocation = trigger.getAttribute("data-scroll-to");
        if (!scrollLocation) {
            return;
        }
        // Deselect current active
        const element = `[data-scroll='${scrollLocation}']`;
        const sectionToScroll = document.querySelector(element);
        if (!sectionToScroll) {
            return;
        }

        animateScrollTo(sectionToScroll, {
            cancelOnUserAction: true,
            speed: 1000
        });
    };

    buttons.forEach((element) => {
        element.addEventListener("click", () => clickHandler(element));
    });
};

const simpleScrollTo = () => {
    const simpleScrollElements =
        document.querySelectorAll(".js-scroll-buttons");

    // if there are no buttons return
    if (!simpleScrollElements) {
        return;
    }

    simpleScrollElements.forEach((container) => {
        setupScrolls(container);
    });
};

document.addEventListener("DOMContentLoaded", async () => {
    simpleScrollTo();
}); 
